import React, { useEffect, useRef, useState } from "react";
import { Modal, LoadingOverlay, CloseIcon,Button } from "@mantine/core";


const WesignModal = ({
  isOpen,
  onRequestClose,
  signUrl,
  handleIframeClose,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [showContinueBtn, setShowContinueBtn] = useState(false);
  const iframeRef = useRef(null);

  // 1. Listen for cross-origin messages from the DocuSign/WeSign iframe
  useEffect(() => {
    const onMessage = (event) => {
      if (event.data?.type === "IFRAME_URL_CHANGED") {
        console.log("Iframe URL changed to:", event.data.url);
        if (event.data.url.includes("postsigning")) {
          setShowContinueBtn(true);
        }
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  // 2. Reset states whenever the modal is opened
  useEffect(() => {
    if (isOpen) {
      setShowContinueBtn(false);
      setIsLoading(true); // Ensure loader shows up on new open
    }
  }, [isOpen]);

  // 3. Combined close handler
  const handleClose = () => {
    setShowContinueBtn(false);
    if (handleIframeClose) handleIframeClose();
    onRequestClose();
  };

  // 4. Hide loader when iframe finishes loading its content
  const onIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <Modal
      opened={isOpen}
      onClose={handleClose}
      fullScreen
      withCloseButton={false}
      transitionProps={{ transition: "slide-up" }}
      padding={0}
    >
      {/* Custom Header */}
      <div
        style={{
          height: "60px",
          background: "#fff",
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
          alignItems: "center",
          borderBottom: "1px solid #eaeaea", // Added a subtle border to separate header
        }}
      >
              <CloseIcon
                  size={25}
          style={{ cursor: "pointer" }}
          onClick={handleClose}
        />
      </div>

      {/* Conditional Continue Button */}
      {showContinueBtn && (
        <div className="d-flex justify-content-end signature-modal-btn">
          <Button onClick={handleClose} className="signature-btn">
            Please press to continue
          </Button>
        </div>
      )}

      {/* Iframe Container with Loading Overlay */}
      <div style={{ position: "relative", height: "calc(100vh - 60px)" }}>
        {/* Mantine Loader specifically scoped to the iframe area */}
        <LoadingOverlay
          visible={isLoading && !!signUrl}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        {signUrl ? (
          <iframe
            src={signUrl}
            ref={iframeRef}
            title="Wesign"
            width="100%"
            height="100%" // Changed to 100% since parent is calc(100vh - 60px)
            onLoad={onIframeLoad}
            style={{ border: "none" }}
          ></iframe>
        ) : (
          <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
            Preparing document...
          </div>
        )}
      </div>
    </Modal>
  );
};

export default WesignModal;